document.addEventListener("algolia.hooks.initialize", function () {

    function getMetaValue(hit, namespace, key) {
    const value = hit?.meta?.[namespace]?.[key];

    // Covers plain values and possible typed/value-shaped objects
    if (value && typeof value === "object" && "value" in value) {
      return value.value;
    }

      return value;
    }

    function isTruthyMeta(value) {
      return value === true ||
        value === "true" ||
        value === "1" ||
        value === 1 ||
        value === "yes";
    }

    function getMedisaveInventoryNote(hit) {
      const fixedLeadTime = getMetaValue(hit, "custom", "fixed_lead_time");
      const leadTime = getMetaValue(hit, "custom", "lead_time");
      const direct = getMetaValue(hit, "custom", "direct");

      const rawQty = hit.inventory_quantity;

      const hasQty =
        rawQty !== undefined &&
        rawQty !== null &&
        rawQty !== "";

      const qty = hasQty ? Number(rawQty) : null;

      const hasValidQty =
        hasQty &&
        !Number.isNaN(qty);

      const inventoryAvailable =
        hit.inventory_available === true ||
        hit.inventory_available === "true";

      const continuesSelling =
        String(hit.inventory_policy || "").toLowerCase() === "continue";

      const available =
        inventoryAvailable ||
        continuesSelling ||
        (hasValidQty && qty > 0);

      if (fixedLeadTime && available) {
        return {
          label: fixedLeadTime,
          className: "pos-stock"
        };
      }

      if (hasValidQty && qty > 100) {
        return {
          label: "100+ in stock",
          className: "pos-stock"
        };
      }

      if (hasValidQty && qty > 0) {
        return {
          label: `${qty} in stock`,
          className: "pos-stock"
        };
      }

      if (leadTime && available) {
        return {
          label: leadTime,
          className: "pos-stock"
        };
      }

      if (isTruthyMeta(direct)) {
        return {
          label: "SPECIAL ORDER",
          className: "pos-stock"
        };
      }

      /**
       * Important:
       * Only show BACKORDER if Algolia has actually returned inventory_quantity.
       * Otherwise missing stock data would make every available product look like BACKORDER.
       */
      if (hasValidQty && qty <= 0 && available) {
        return {
          label: "BACKORDER",
          className: "pos-stock pos-stock--backorder"
        };
      }

      return null;
    }

  /**
   * Collections to hide from the Collections section in autocomplete.
   * Use Shopify collection handles, e.g.
   * /collections/littmann-without-discount
   * becomes "littmann-without-discount"
   */
  const excludedCollectionHandles = new Set([
    "littmann-without-discount"
    // Add more handles here, for example:
    // "competition",
    // "clearance",
  ]);

  /**
   * Autocomplete product cards
   */
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution
    ) {
      const { html, item, components } = templateOptions;
      const inventoryNote = getMedisaveInventoryNote(item);

      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => trackSearchAttribution(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                alt="${item.title}"
              />
            </div>

            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle medisave-aa-product-title">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                  </span>
                </div>
              </div>

              ${item.sku &&
              html`
                <div class="algolia-result-sku algolia-autocomplete-sku">
                  SKU: ${components.Highlight({ hit: item, attribute: "sku" })}
                </div>
              `}

              ${false && inventoryNote &&
              html`
                <div class="inventoryNote algolia-inventory-note">
                  <div class="${inventoryNote.className}">
                    <span class="stock-qty">${inventoryNote.label}</span>
                  </div>
                </div>
              `}

              <div class="aa-ItemContentPrice">
                <div
                  class="aa-ItemContentPriceCurrent medisave-spark-price medisave-spark-price-autocomplete"
                  data-medisave-product-id="${item.id}"
                  data-medisave-variant-id="${item.objectID}"
                  data-medisave-sku="${item.sku}"
                >
                  ${algoliaShopify.helpers.displayPrice(item, distinct)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  /**
   * InstantSearch product cards
   */
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      return html`
        <div
          class="ais-hit ais-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          onClick="${() => trackSearchAttribution(hit)}"
        >
          <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(hit)}"
              alt="${hit.title}"
            />
          </a>

          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                ${components.Highlight({ attribute: "title", hit })}
                ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
              </a>
            </p>

            ${hit.sku &&
            html`
              <p class="algolia-result-sku algolia-instantsearch-sku">
                SKU: ${components.Highlight({ attribute: "sku", hit })}
              </p>
            `}

            ${hit.vendor &&
            html`
              <p class="ais-hit--vendor">
                ${components.Highlight({ attribute: "vendor", hit })}
              </p>
            `}

            <p
              class="ais-hit--price medisave-algolia-price medisave-spark-price"
              data-medisave-product-id="${hit.id}"
              data-medisave-variant-id="${hit.objectID}"
              data-medisave-sku="${hit.sku}"
            >
              <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
            </p>
          </div>
        </div>
      `;
    }
  );


  /**
 * Medisave: Helpful Pages widget on Algolia InstantSearch results page
 * Manually queries the Shopify Pages index, e.g. shopify_pages.
 */
function escapeMedisaveHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function getMedisaveSearchQuery() {
  const root = document.querySelector("#algolia-shopify-instantsearch");

  const input = root
    ? root.querySelector("input[type='search'], input[type='text']")
    : null;

  if (input && input.value) {
    return input.value.trim();
  }

  return new URLSearchParams(window.location.search).get("q") || "";
}

function getMedisavePageUrl(hit) {
  if (hit.url) {
    return hit.url;
  }

  if (hit.handle) {
    return `/pages/${hit.handle}`;
  }

  return "#";
}

function ensureMedisavePagesWidget() {
  let widget = document.querySelector("#medisave-algolia-pages-widget");

  if (widget) {
    return widget;
  }

  const searchHeader = document.querySelector(
    "#algolia-shopify-instantsearch .ais-search-header"
  );

  if (!searchHeader || !searchHeader.parentNode) {
    return null;
  }

  widget = document.createElement("div");
  widget.id = "medisave-algolia-pages-widget";
  widget.className = "medisave-algolia-pages-widget";
  widget.hidden = true;

  searchHeader.parentNode.insertBefore(widget, searchHeader);

  return widget;
}

let medisavePagesLastQuery = "";
let medisavePagesTimer = null;

async function renderMedisavePagesWidget() {
  const config = window.algoliaShopify && window.algoliaShopify.config;
  const widget = ensureMedisavePagesWidget();
  const query = getMedisaveSearchQuery();

  if (!config || !widget || !query || query.length < 2) {
    if (widget) {
      widget.hidden = true;
      widget.innerHTML = "";
    }
    return;
  }

  if (query === medisavePagesLastQuery && widget.innerHTML) {
    return;
  }

  medisavePagesLastQuery = query;

  const indexName = `${config.index_prefix || "shopify_"}pages`;

  try {
    const response = await fetch(
      `https://${config.app_id}-dsn.algolia.net/1/indexes/${encodeURIComponent(indexName)}/query`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Algolia-Application-Id": config.app_id,
          "X-Algolia-API-Key": config.search_api_key
        },
        body: JSON.stringify({
          params: new URLSearchParams({
          query: query,
          hitsPerPage: "4",
          attributesToRetrieve: "title,handle,url,objectID",
          // restrictSearchableAttributes: "title,handle"
        }).toString()
        })
      }
    );

    const data = await response.json();
    const hits = data.hits || [];

    if (!hits.length) {
      widget.hidden = true;
      widget.innerHTML = "";
      return;
    }

    widget.hidden = false;

    widget.innerHTML = `
      <div class="medisave-algolia-pages-inner">
        <h2 class="medisave-algolia-pages-heading">Related Info</h2>
        <ul class="medisave-algolia-pages-list">
          ${hits
            .map(function (hit) {
              const title = escapeMedisaveHtml(hit.title || hit.handle || "Page");
              const url = escapeMedisaveHtml(getMedisavePageUrl(hit));

              return `
                <li class="medisave-algolia-pages-item">
                  <a class="medisave-algolia-page-link" href="${url}">
                    ${title}
                  </a>
                </li>
              `;
            })
            .join("")}
        </ul>
      </div>
    `;
  } catch (error) {
    console.warn("Medisave Algolia pages widget failed:", error);
    widget.hidden = true;
  }
}

function scheduleMedisavePagesWidgetRender() {
  clearTimeout(medisavePagesTimer);

  medisavePagesTimer = setTimeout(function () {
    renderMedisavePagesWidget();
  }, 250);
}

function initMedisavePagesWidget() {
  const root = document.querySelector("#algolia-shopify-instantsearch");

  if (!root) {
    return false;
  }

  root.addEventListener("input", scheduleMedisavePagesWidgetRender);
  root.addEventListener("change", scheduleMedisavePagesWidgetRender);

  scheduleMedisavePagesWidgetRender();

  return true;
}

let medisavePagesInitAttempts = 0;

const medisavePagesInitInterval = setInterval(function () {
  medisavePagesInitAttempts += 1;

  if (initMedisavePagesWidget() || medisavePagesInitAttempts > 20) {
    clearInterval(medisavePagesInitInterval);
  }
}, 250);

function formatMedisaveCurrency(amount, currencyCode) {
  const currency = String(currencyCode || "GBP").toUpperCase();

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency
  }).format(Number(amount));
}

async function updateMedisaveSparkLayerPrices() {
  if (
    !window.spark ||
    typeof window.spark.calculatePricingForVariant !== "function"
  ) {
    return;
  }

  const priceEls = document.querySelectorAll(
    "#algolia-shopify-instantsearch .medisave-spark-price:not([data-spark-price-loaded]), " +
    ".aa-Panel .medisave-spark-price:not([data-spark-price-loaded])"
  );

  if (!priceEls.length) {
    return;
  }

  for (const el of priceEls) {
    const productId = el.dataset.medisaveProductId;
    const sku = el.dataset.medisaveSku;

    if (!productId || !sku) {
      continue;
    }

    el.dataset.sparkPriceLoaded = "loading";

    try {
      const pricing = await window.spark.calculatePricingForVariant(
        productId,
        sku,
        1
      );

      if (pricing && pricing.unitPrice !== undefined && pricing.unitPrice !== null) {
        el.innerHTML = `<b>${formatMedisaveCurrency(
          pricing.unitPrice,
          pricing.currencyCode
        )}</b>`;

        el.dataset.sparkPriceLoaded = "true";
      } else {
        el.dataset.sparkPriceLoaded = "no-price";
      }
    } catch (error) {
      console.warn("SparkLayer price failed for Algolia result:", {
        productId: productId,
        sku: sku,
        error: error
      });

      el.dataset.sparkPriceLoaded = "error";
    }
  }
}

function scheduleMedisaveSparkLayerPriceUpdate() {
  clearTimeout(window.medisaveSparkPriceTimer);

  window.medisaveSparkPriceTimer = setTimeout(function () {
    updateMedisaveSparkLayerPrices();
  }, 250);
}

function initMedisaveSparkLayerAutocompletePriceObserver() {
  if (document.body.dataset.sparkAutocompletePriceObserverAttached) {
    return;
  }

  document.body.dataset.sparkAutocompletePriceObserverAttached = "true";

  const observer = new MutationObserver(function () {
    scheduleMedisaveSparkLayerPriceUpdate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  scheduleMedisaveSparkLayerPriceUpdate();
}

initMedisaveSparkLayerAutocompletePriceObserver();
function initMedisaveSparkLayerPriceObserver() {
  const hitsContainer = document.querySelector(
    "#algolia-shopify-instantsearch .ais-hits-container"
  );

  if (!hitsContainer || hitsContainer.dataset.sparkPriceObserverAttached) {
    return;
  }

  hitsContainer.dataset.sparkPriceObserverAttached = "true";

  const observer = new MutationObserver(function () {
    scheduleMedisaveSparkLayerPriceUpdate();
  });

  observer.observe(hitsContainer, {
    childList: true,
    subtree: true
  });

  scheduleMedisaveSparkLayerPriceUpdate();
}

let medisaveSparkPriceObserverAttempts = 0;

const medisaveSparkPriceObserverInterval = setInterval(function () {
  medisaveSparkPriceObserverAttempts += 1;

  initMedisaveSparkLayerPriceObserver();

  if (
    document.querySelector("#algolia-shopify-instantsearch .ais-hits-container") ||
    medisaveSparkPriceObserverAttempts > 20
  ) {
    clearInterval(medisaveSparkPriceObserverInterval);
  }
}, 250);

});